<template>
  <div class="feedback-management">
    <div class="page-header">
      <h2>意见反馈管理</h2>
    </div>

    <!-- 统计卡片 -->
    <div class="stats-cards">
      <el-card class="stat-card">
        <div class="stat-content">
          <div class="stat-label">反馈总数</div>
          <div class="stat-value">{{ statistics.total_feedback || 0 }}</div>
        </div>
      </el-card>
      <el-card class="stat-card">
        <div class="stat-content">
          <div class="stat-label">待处理</div>
          <div class="stat-value stat-value-warning">{{ statistics.pending_count || 0 }}</div>
        </div>
      </el-card>
      <el-card class="stat-card">
        <div class="stat-content">
          <div class="stat-label">处理中</div>
          <div class="stat-value stat-value-primary">{{ statistics.processing_count || 0 }}</div>
        </div>
      </el-card>
      <el-card class="stat-card">
        <div class="stat-content">
          <div class="stat-label">已处理</div>
          <div class="stat-value stat-value-success">{{ statistics.completed_count || 0 }}</div>
        </div>
      </el-card>
      <el-card class="stat-card">
        <div class="stat-content">
          <div class="stat-label">已关闭</div>
          <div class="stat-value stat-value-info">{{ statistics.closed_count || 0 }}</div>
        </div>
      </el-card>
      <el-card class="stat-card">
        <div class="stat-content">
          <div class="stat-label">今日反馈</div>
          <div class="stat-value stat-value-purple">{{ statistics.today_feedback || 0 }}</div>
        </div>
      </el-card>
    </div>

    <!-- 搜索表单 -->
    <el-form :inline="true" :model="searchForm" class="search-form">
      <el-form-item label="反馈类型">
        <el-select v-model="searchForm.feedback_type" placeholder="请选择" clearable>
          <el-option label="功能建议" :value="1" />
          <el-option label="BUG反馈" :value="2" />
          <el-option label="投诉建议" :value="3" />
          <el-option label="其他" :value="4" />
        </el-select>
      </el-form-item>
      <el-form-item label="处理状态">
        <el-select v-model="searchForm.status" placeholder="请选择" clearable>
          <el-option label="待处理" :value="0" />
          <el-option label="处理中" :value="1" />
          <el-option label="已处理" :value="2" />
          <el-option label="已关闭" :value="3" />
        </el-select>
      </el-form-item>
      <el-form-item label="关键词">
        <el-input v-model="searchForm.keyword" placeholder="标题/内容/用户名" clearable />
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          style="width: 300px;"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>

    <!-- 数据表格 -->
    <el-table v-loading="loading" :data="feedbackList" border style="width: 100%">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column label="用户信息" width="150">
        <template slot-scope="scope">
          <div class="user-info">
            <div class="user-name">{{ scope.row.user_name }}</div>
            <div class="mobile">{{ scope.row.mobile }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="feedback_type" label="反馈类型" width="100">
        <template slot-scope="scope">
          <el-tag :type="getFeedbackTypeTagType(scope.row.feedback_type)">
            {{ getFeedbackTypeName(scope.row.feedback_type) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" min-width="150" show-overflow-tooltip />
      <el-table-column prop="content" label="内容" min-width="200" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.content }}
        </template>
      </el-table-column>
      <el-table-column label="图片" width="80" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.image_list && scope.row.image_list.length > 0" type="info" size="mini">
            {{ scope.row.image_list.length }}张
          </el-tag>
          <span v-else class="text-gray">无</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="处理状态" width="100">
        <template slot-scope="scope">
          <el-tag :type="getStatusTagType(scope.row.status)">
            {{ getStatusName(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="回复状态" width="100" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.reply_content" type="success" size="mini">已回复</el-tag>
          <el-tag v-else type="warning" size="mini">未回复</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="create_time" label="创建时间" width="180" />
      <el-table-column label="操作" width="220" fixed="right">
        <template slot-scope="scope">
          <div class="table-operations">
            <el-button size="mini" type="text" @click="handleView(scope.row)">查看</el-button>
            <el-button size="mini" type="text" class="reply-btn" @click="handleReply(scope.row)">回复</el-button>
            <el-button size="mini" type="text" @click="handleUpdateStatus(scope.row)">状态</el-button>
            <el-button size="mini" type="text" class="delete-btn" @click="handleDelete(scope.row)">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        :current-page="pagination.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.limit"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 查看详情对话框 -->
    <el-dialog title="反馈详情" :visible.sync="viewDialogVisible" width="800px">
      <div v-if="currentFeedback" class="feedback-detail">
        <!-- 基本信息 -->
        <div class="detail-section">
          <div class="section-title">基本信息</div>
          <div class="detail-table">
            <div class="detail-row">
              <div class="detail-label">反馈ID</div>
              <div class="detail-value">{{ currentFeedback.id }}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">用户信息</div>
              <div class="detail-value">
                {{ currentFeedback.user_name }} ({{ currentFeedback.mobile }})
              </div>
            </div>
            <div class="detail-row">
              <div class="detail-label">反馈类型</div>
              <div class="detail-value">
                <el-tag :type="getFeedbackTypeTagType(currentFeedback.feedback_type)">
                  {{ getFeedbackTypeName(currentFeedback.feedback_type) }}
                </el-tag>
              </div>
            </div>
            <div class="detail-row">
              <div class="detail-label">反馈标题</div>
              <div class="detail-value">{{ currentFeedback.title || '-' }}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">反馈内容</div>
              <div class="detail-value content-text">{{ currentFeedback.content }}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">处理状态</div>
              <div class="detail-value">
                <el-tag :type="getStatusTagType(currentFeedback.status)">
                  {{ getStatusName(currentFeedback.status) }}
                </el-tag>
              </div>
            </div>
            <div class="detail-row">
              <div class="detail-label">创建时间</div>
              <div class="detail-value">{{ currentFeedback.create_time }}</div>
            </div>
          </div>
        </div>

        <!-- 反馈图片 -->
        <div v-if="currentFeedback.image_list && currentFeedback.image_list.length > 0" class="detail-section">
          <div class="section-title">反馈图片</div>
          <div class="image-list">
            <el-image
              v-for="(img, index) in currentFeedback.image_list"
              :key="index"
              :src="img"
              :preview-src-list="currentFeedback.image_list"
              fit="cover"
              class="feedback-image"
            />
          </div>
        </div>

        <!-- 设备信息 -->
        <div v-if="currentFeedback.device_info" class="detail-section">
          <div class="section-title">设备信息</div>
          <div class="detail-table">
            <div class="detail-row">
              <div class="detail-label">平台</div>
              <div class="detail-value">{{ currentFeedback.device_info.platform || '-' }}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">设备型号</div>
              <div class="detail-value">{{ currentFeedback.device_info.model || '-' }}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">系统版本</div>
              <div class="detail-value">{{ currentFeedback.device_info.system || '-' }}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">APP版本</div>
              <div class="detail-value">{{ currentFeedback.device_info.app_version || '-' }}</div>
            </div>
          </div>
        </div>

        <!-- 回复信息 -->
        <div v-if="currentFeedback.reply_content" class="detail-section">
          <div class="section-title">回复信息</div>
          <div class="detail-table">
            <div class="detail-row">
              <div class="detail-label">回复内容</div>
              <div class="detail-value content-text">{{ currentFeedback.reply_content }}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">回复人</div>
              <div class="detail-value">{{ currentFeedback.reply_user_name }}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">回复时间</div>
              <div class="detail-value">{{ currentFeedback.reply_time }}</div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="viewDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="handleReplyFromDetail">回复</el-button>
      </div>
    </el-dialog>

    <!-- 回复对话框 -->
    <el-dialog title="回复反馈" :visible.sync="replyDialogVisible" width="700px">
      <el-form ref="replyForm" :model="replyForm" :rules="replyRules" label-width="100px">
        <div v-if="currentFeedback" class="reply-feedback-info">
          <div class="info-item">
            <span class="info-label">反馈类型：</span>
            <el-tag :type="getFeedbackTypeTagType(currentFeedback.feedback_type)" size="mini">
              {{ getFeedbackTypeName(currentFeedback.feedback_type) }}
            </el-tag>
          </div>
          <div class="info-item">
            <span class="info-label">用户：</span>
            <span>{{ currentFeedback.user_name }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">标题：</span>
            <span>{{ currentFeedback.title || '无' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">内容：</span>
            <span class="content-preview">{{ currentFeedback.content }}</span>
          </div>
          <div v-if="currentFeedback.reply_content" class="history-reply">
            <div class="history-label">历史回复：</div>
            <div class="history-content">{{ currentFeedback.reply_content }}</div>
          </div>
        </div>
        <el-divider />
        <el-form-item label="回复内容" prop="reply_content">
          <el-input
            v-model="replyForm.reply_content"
            type="textarea"
            :rows="6"
            placeholder="请输入回复内容"
            maxlength="1000"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="处理状态" prop="status">
          <el-select v-model="replyForm.status" placeholder="请选择状态" style="width: 100%">
            <el-option label="待处理" :value="0" />
            <el-option label="处理中" :value="1" />
            <el-option label="已处理" :value="2" />
            <el-option label="已关闭" :value="3" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="replyDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitting" @click="submitReply">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 更新状态对话框 -->
    <el-dialog title="更新状态" :visible.sync="statusDialogVisible" width="400px">
      <el-form ref="statusForm" :model="statusForm" label-width="100px">
        <el-form-item label="当前状态">
          <el-tag :type="getStatusTagType(currentStatus)">
            {{ getStatusName(currentStatus) }}
          </el-tag>
        </el-form-item>
        <el-form-item label="新状态">
          <el-select v-model="statusForm.status" placeholder="请选择状态" style="width: 100%">
            <el-option label="待处理" :value="0" />
            <el-option label="处理中" :value="1" />
            <el-option label="已处理" :value="2" />
            <el-option label="已关闭" :value="3" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="statusDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitUpdateStatus">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getFeedbackList, getFeedbackDetail, replyFeedback, updateFeedbackStatus, deleteFeedback, getFeedbackStatistics } from '@/api/feedback'

export default {
  name: 'FeedbackManagement',
  data() {
    return {
      loading: false,
      feedbackList: [],
      statistics: {},
      searchForm: {
        feedback_type: '',
        status: '',
        keyword: ''
      },
      dateRange: [],
      pagination: {
        page: 1,
        limit: 20,
        total: 0
      },
      viewDialogVisible: false,
      replyDialogVisible: false,
      statusDialogVisible: false,
      currentFeedback: null,
      currentStatus: 0,
      replyForm: {
        id: null,
        reply_content: '',
        status: 2
      },
      replyRules: {
        reply_content: [
          { required: true, message: '请输入回复内容', trigger: 'blur' },
          { min: 5, max: 1000, message: '长度在 5 到 1000 个字符', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择处理状态', trigger: 'change' }
        ]
      },
      statusForm: {
        id: null,
        status: 0
      },
      submitting: false
    }
  },
  mounted() {
    this.fetchFeedbackList()
    this.fetchStatistics()
  },
  methods: {
    async fetchFeedbackList() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.page,
          limit: this.pagination.limit,
          ...this.searchForm
        }
        if (this.dateRange && this.dateRange.length === 2) {
          params.start_time = this.dateRange[0]
          params.end_time = this.dateRange[1]
        }
        const response = await getFeedbackList(params)
        this.feedbackList = response.data.list || []
        this.pagination.total = response.data.total || 0
      } catch (error) {
        console.error('获取反馈列表失败:', error)
      } finally {
        this.loading = false
      }
    },
    async fetchStatistics() {
      try {
        const response = await getFeedbackStatistics()
        this.statistics = response.data || {}
      } catch (error) {
        console.error('获取统计数据失败:', error)
      }
    },
    handleSearch() {
      this.pagination.page = 1
      this.fetchFeedbackList()
    },
    handleReset() {
      this.searchForm = {
        feedback_type: '',
        status: '',
        keyword: ''
      }
      this.dateRange = []
      this.pagination.page = 1
      this.fetchFeedbackList()
    },
    handleSizeChange(size) {
      this.pagination.limit = size
      this.fetchFeedbackList()
    },
    handleCurrentChange(page) {
      this.pagination.page = page
      this.fetchFeedbackList()
    },
    async handleView(row) {
      try {
        const response = await getFeedbackDetail(row.id)
        this.currentFeedback = response.data
        this.viewDialogVisible = true
      } catch (error) {
        console.error('获取反馈详情失败:', error)
      }
    },
    async handleReply(row) {
      try {
        const response = await getFeedbackDetail(row.id)
        this.currentFeedback = response.data
        this.replyForm = {
          id: row.id,
          reply_content: '',
          status: row.status === 0 ? 2 : row.status
        }
        this.replyDialogVisible = true
        this.$nextTick(() => {
          this.$refs.replyForm && this.$refs.replyForm.clearValidate()
        })
      } catch (error) {
        console.error('获取反馈详情失败:', error)
      }
    },
    async submitReply() {
      this.$refs.replyForm.validate(async (valid) => {
        if (valid) {
          this.submitting = true
          try {
            await replyFeedback(this.replyForm)
            this.$message.success('回复成功')
            this.replyDialogVisible = false
            this.fetchFeedbackList()
            this.fetchStatistics()
          } catch (error) {
            console.error('回复失败:', error)
          } finally {
            this.submitting = false
          }
        }
      })
    },
    handleReplyFromDetail() {
      this.viewDialogVisible = false
      this.handleReply(this.currentFeedback)
    },
    handleUpdateStatus(row) {
      this.currentFeedback = row
      this.currentStatus = row.status
      this.statusForm = {
        id: row.id,
        status: row.status
      }
      this.statusDialogVisible = true
    },
    async submitUpdateStatus() {
      if (this.statusForm.status === this.currentStatus) {
        this.$message.warning('状态未发生变化')
        return
      }
      try {
        await updateFeedbackStatus(this.statusForm)
        this.$message.success('状态更新成功')
        this.statusDialogVisible = false
        this.fetchFeedbackList()
        this.fetchStatistics()
      } catch (error) {
        console.error('状态更新失败:', error)
      }
    },
    handleDelete(row) {
      this.$confirm('确认删除该反馈吗？删除后不可恢复！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await deleteFeedback(row.id)
          this.$message.success('删除成功')
          this.fetchFeedbackList()
          this.fetchStatistics()
        } catch (error) {
          console.error('删除失败:', error)
        }
      })
    },
    getFeedbackTypeName(type) {
      const map = { 1: '功能建议', 2: 'BUG反馈', 3: '投诉建议', 4: '其他' }
      return map[type] || '-'
    },
    getFeedbackTypeTagType(type) {
      const map = { 1: 'success', 2: 'danger', 3: 'warning', 4: 'info' }
      return map[type] || ''
    },
    getStatusName(status) {
      const map = { 0: '待处理', 1: '处理中', 2: '已处理', 3: '已关闭' }
      return map[status] || '-'
    },
    getStatusTagType(status) {
      const map = { 0: 'warning', 1: 'primary', 2: 'success', 3: 'info' }
      return map[status] || ''
    }
  }
}
</script>

<style scoped>
.feedback-management {
  padding: 20px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
  font-size: 24px;
  color: #303133;
}

/* 统计卡片 */
.stats-cards {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 15px;
  margin-bottom: 20px;
}

.stat-card {
  border-radius: 8px;
  overflow: hidden;
}

.stat-card :deep(.el-card__body) {
  padding: 20px;
}

.stat-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.stat-label {
  font-size: 14px;
  color: #909399;
  margin-bottom: 10px;
}

.stat-value {
  font-size: 28px;
  font-weight: 600;
  color: #303133;
}

.stat-value-success {
  color: #67c23a;
}

.stat-value-warning {
  color: #e6a23c;
}

.stat-value-primary {
  color: #409eff;
}

.stat-value-info {
  color: #909399;
}

.stat-value-purple {
  color: #9b59b6;
}

.search-form {
  background: #f5f5f5;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

/* 用户信息 */
.user-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.user-name {
  font-weight: 500;
  color: #303133;
}

.mobile {
  font-size: 12px;
  color: #909399;
}

.text-gray {
  color: #c0c4cc;
}

/* 表格操作 */
.table-operations {
  display: flex;
  gap: 8px;
  justify-content: center;
  flex-wrap: nowrap;
}

.table-operations .el-button--text {
  padding: 2px 8px;
  font-size: 12px;
  border: none;
  background: none;
}

.table-operations .reply-btn {
  color: #67c23a;
}

.table-operations .reply-btn:hover {
  color: #85ce61;
  background-color: #f0f9ff;
}

.table-operations .delete-btn {
  color: #f56c6c;
}

.table-operations .delete-btn:hover {
  color: #f78989;
  background-color: #fef0f0;
}

.dialog-footer {
  text-align: right;
}

/* 详情样式 */
.feedback-detail {
  padding: 10px 0;
}

.detail-section {
  margin-bottom: 30px;
}

.detail-section:last-child {
  margin-bottom: 0;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 15px;
  padding-left: 10px;
  border-left: 4px solid #409EFF;
  line-height: 20px;
}

.detail-table {
  border: 1px solid #EBEEF5;
  border-radius: 4px;
  overflow: hidden;
  background-color: #fff;
}

.detail-row {
  display: flex;
  border-bottom: 1px solid #EBEEF5;
  min-height: 50px;
  align-items: center;
}

.detail-row:last-child {
  border-bottom: none;
}

.detail-label {
  font-weight: 500;
  color: #606266;
  width: 120px;
  text-align: right;
  padding: 15px 20px;
  background-color: #FAFAFA;
  border-right: 1px solid #EBEEF5;
  flex-shrink: 0;
  box-sizing: border-box;
}

.detail-value {
  color: #303133;
  word-break: break-word;
  padding: 15px 20px;
  flex: 1;
  box-sizing: border-box;
}

.content-text {
  white-space: pre-wrap;
  line-height: 1.6;
}

/* 图片列表 */
.image-list {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.feedback-image {
  width: 100px;
  height: 100px;
  border-radius: 4px;
  cursor: pointer;
}

/* 回复信息 */
.reply-feedback-info {
  background-color: #f5f7fa;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.info-item {
  margin-bottom: 10px;
  display: flex;
  align-items: flex-start;
}

.info-item:last-child {
  margin-bottom: 0;
}

.info-label {
  font-weight: 500;
  color: #606266;
  margin-right: 10px;
  flex-shrink: 0;
}

.content-preview {
  color: #606266;
  line-height: 1.6;
}

.history-reply {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #DCDFE6;
}

.history-label {
  font-weight: 500;
  color: #909399;
  margin-bottom: 8px;
}

.history-content {
  color: #606266;
  line-height: 1.6;
  padding: 10px;
  background-color: #fff;
  border-radius: 4px;
}
</style>
